import React, { useState } from 'react';
import Pdf from './placeholder3.png'; // fallback dummy image

const ImageWithFallback = ({ url, className, style={} }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const imageSource = url && !imageError ? url : Pdf;

  return (
    <img
      src={imageSource}
      className={className}
      onError={handleImageError}
      alt="preview"
      style={style}
    />
  );
};

export default ImageWithFallback;
